export const handleSwiperTranslate = (e: any) => {
  if (!e || !e.slides.length) return

  const checkedProgress = checkProgress(e.progress)

  const l = e.slides.length > 0 ? e.slides.length : 1

  const length = 1 / (l - 1)

  const leftIndex = Math.floor(checkedProgress / length)
  const rightIndex = Math.ceil(checkedProgress / length)
  //TO DO middle chip index
  const leftSlide = e.slides[leftIndex]
  const rightSlide = e.slides[rightIndex]

  const leftChip = leftSlide?.firstChild
  const rightChip = rightSlide?.firstChild

  const leftScale = length - (checkedProgress % length)
  const rightScale = checkedProgress % length

  leftSlide.style.transform = `scale(${checkScale(1 + leftScale * 7)})`
  rightSlide.style.transform = `scale(${checkScale(1 + rightScale * 7)})`

  const leftRed = Math.floor(2 + 657.14 * leftScale * 7)
  const leftGreen = Math.floor(84 + 238.86 * leftScale * 7)
  const leftBlue = Math.floor(48 - 124.67 * leftScale * 7)

  const rightRed = Math.floor(2 + 657.14 * rightScale * 7)
  const rightGreen = Math.floor(84 + 238.86 * rightScale * 7)
  const rightBlue = Math.floor(48 - 124.67 * rightScale * 7)

  //max left scale = 0.055
  const greenToYellow = `rgb(${leftRed} , ${leftGreen}, ${leftBlue})`
  const YellowToBlue = `rgb(${rightRed} , ${rightGreen}, ${rightBlue})`

  leftChip.style.background = greenToYellow
  rightChip.style.background = YellowToBlue
  leftChip.firstChild.style.borderColor = YellowToBlue
  leftChip.style.borderColor = greenToYellow
  rightChip.firstChild.style.borderColor = greenToYellow
  rightChip.style.borderColor = YellowToBlue
  leftChip.firstChild.style.color = YellowToBlue
  rightChip.firstChild.style.color = greenToYellow
  for (let i = 0; i < e.slides.length; i++) {
    if (i !== leftIndex && i !== rightIndex) {
      e.slides[i].firstChild.style.background = `rgb(2, 84, 48)`
      e.slides[i].style.transform = `scale(1)`
      e.slides[i].firstChild.firstChild.style.borderColor = 'rgb(255, 176, 0)'
      e.slides[i].firstChild.style.borderColor = 'rgb(2, 84, 48)'
      e.slides[i].firstChild.firstChild.style.color = 'rgb(255, 176, 0)'
    }
  }
}

const checkScale = (scale: number) => {
  return scale >= 1.36 ? 1.36 : scale
}
const checkProgress = (progress: number) => {
  if (progress <= 0) {
    return 0
  } else if (progress >= 1) {
    return 1
  } else {
    return progress
  }
}
